const filterFalsyParameters = (
  queryParameters: Record<string, any>,
): Record<string, string> => {
  return Object.keys(queryParameters).reduce<Record<string, string>>(
    (acc, key) => {
      if (queryParameters[key]) {
        acc[key] = queryParameters[key];
      }
      return acc;
    },
    {},
  );
};

export default filterFalsyParameters;
